<template>

    <section class="dd-m-carousel dd-m-carousel--top-banner" v-if="show">
    
        <h2 class="dd-m-carousel--default__title">{{ getTranslateString('Find the perfect match for you')}}</h2>
    
        <div v-if="isLoading">
            <loading type="bannertop"></loading>
        </div>

        <div v-if="results.length">
            <div class="dd-m-carousel__slider">
                <Slick ref="slick" :options="slickOptions">
                <card-banner-top v-for="(item, index) in results"
                                     :item="item"
                                     :key="index"></card-banner-top>
                </Slick>
            </div>
        </div>
    </section>

</template>

<script>
    import SlickOptions from '../../providers/slick';
    import BannerService from "../../providers/api/banner-service";
    import Loading from "../loading";
    import CardBannerTop from "../cards/card-banner-top";
    import Slick from 'vue-slick';

    const slickOptions = new SlickOptions(),
        bannerService = new BannerService();

    export default {
        name: 'banner-list-top',
        components: {CardBannerTop, Loading, Slick},
        props: [
            'perPage'
        ],
        data: () => {
            return {
                results: [],
                slickOptions: slickOptions.getCustomWithArrows(),
                isLoading: false,
                show: true
            }
        },
        mounted() {
            this.doGetList();
            this.subscribe();
        },
        methods: {
            doGetList() {
                this.isLoading = true;

                const params = {
                    perPage: this.perPage ? this.perPage : ''
                };

                bannerService.doGetByType(1, params)
                    .then((res) => {
                        this.results = res.data.data;
                        if (this.results.length) $('#dd-container-home').removeClass('dd-l-container--has-top');
                        this.isLoading = false;
                    })
                    .catch(() => this.isLoading = false);
            },
            subscribe() {
                PubSub.subscribe('statusChanged', (msg, isOnline) => this.show = isOnline);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-list-top.vue